var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-or-close"},[_c('p',{staticClass:"text"},[_vm._v("打开或者关闭首页按钮")]),_c('a-switch',{on:{"change":_vm.onChange},model:{value:(_vm.checkIs),callback:function ($$v) {_vm.checkIs=$$v},expression:"checkIs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }